<span class="inline-preloader-wrapper">
    <img class="img-inline-preloader" src="{{ mediaServer }}/zeta/common/preloader.png" alt="..."/>
</span>